import { render, staticRenderFns } from "./AbsentsView.vue?vue&type=template&id=264a5507"
import script from "./AbsentsView.vue?vue&type=script&lang=js"
export * from "./AbsentsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports